import 'whatwg-fetch';
import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';
import { LoggerService } from './logger-service';
import { BrowserStorageService } from './browser-storage-service';

var config = require('../../../config.js');
var version = require('../../../version.json');

@inject(HttpClient, LoggerService, BrowserStorageService)
export class WebLoggerService {
    constructor(httpClient, logger, browserStorage) {
        this.httpClient = httpClient;
        this.logger = logger;
        this.browserStorage = browserStorage;
    }

    logEvent(httpStatusCode, message, subComponent, stackTrace, severity) {
        this.logger.debug('logEvent() called');
        let that = this;
        var url = config.webLoggerUrl;
        var username = this.browserStorage.getItem('userName');
        var component = 'Advertiser Portal';

        message =
            'Role: ' +
            this.browserStorage.getItem('role') +
            ' AdvertiserKey: ' +
            this.browserStorage.getItem('advertiserKey') +
            ' Message: ' +
            message;

        var jsonData = {
            username: username,
            http_code: httpStatusCode,
            message: message,
            component: component,
            subcomponent: subComponent,
            stack_trace: stackTrace,
            severity: severity,
            build_version: version.version
        };

        this.httpClient.configure(config => {
            config.withBaseUrl('/');
        });
        this.post(url, jsonData).then(response => {
            that.logger.debug('weblogger.post() returns:', response);
        });
    }

    post(url, postData) {
        this.logger.debug('weblogger.post() called');
        let that = this;

        let allHeaders = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };

        this.httpClient.configure(httpConfig => {
            httpConfig.withBaseUrl('/').withDefaults({
                headers: allHeaders.headers
            });
        });

        return Promise.all([
            this.httpClient
                .fetch(url, {
                    mode: 'cors',
                    method: 'POST',
                    body: JSON.stringify(postData)
                })
                .then(response => response.json())
                .then(response => {
                    if (response.status == 'SUCCESS') {
                        return {
                            status: 'SUCCESS'
                        };
                    } else {
                        return {
                            status: 'ERROR',
                            errors: response.errors
                        };
                    }
                })
        ]);
    }
}
